import React from 'react';
import { Trash2, Plus, Minus } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartItem = ({ item }) => {
  const { updateQuantity, removeFromCart } = useCart();

  return (
    <div className="bg-white/80 backdrop-blur-xl rounded-xl sm:rounded-2xl shadow-lg p-3 sm:p-6">
      <div className="flex items-center gap-2 sm:gap-4">

        {/* IMAGE */}
        <img
          src={item.image}
          alt={item.name}
          className="
            w-12 h-12
            sm:w-20 sm:h-20
            object-cover rounded-lg sm:rounded-xl
            flex-shrink-0
          "
        />

        {/* PRODUCT INFO */}
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-sm sm:text-lg text-gray-800 truncate">
            {item.name}
          </h3>
          <p className="text-xs sm:text-sm text-gray-600 truncate">
            {item.category}
          </p>
          <p className="text-sm sm:text-xl font-bold text-purple-600 mt-1 sm:mt-2">
            ₹{item.price}
          </p>
        </div>

        {/* QUANTITY CONTROLS */}
        <div className="flex items-center space-x-1 sm:space-x-3">
          <button
            onClick={() => updateQuantity(item._id, item.quantity - 1)}
            className="
              w-6 h-6 sm:w-8 sm:h-8
              bg-gray-100 rounded-md sm:rounded-lg
              hover:bg-gray-200
              flex items-center justify-center
            "
          >
            <Minus size={12} className="sm:hidden" />
            <Minus size={16} className="hidden sm:block" />
          </button>

          <span className="font-bold text-xs sm:text-base text-gray-800 w-5 sm:w-8 text-center">
            {item.quantity}
          </span>

          <button
            onClick={() => updateQuantity(item._id, item.quantity + 1)}
            disabled={item.quantity >= item.stock}
            className="
              w-6 h-6 sm:w-8 sm:h-8
              bg-gray-100 rounded-md sm:rounded-lg
              hover:bg-gray-200
              flex items-center justify-center
              disabled:opacity-50
            "
          >
            <Plus size={12} className="sm:hidden" />
            <Plus size={16} className="hidden sm:block" />
          </button>
        </div>

        {/* SUBTOTAL */}
        <div className="text-right hidden sm:block">
          <p className="text-sm text-gray-600">Subtotal</p>
          <p className="text-xl font-bold text-gray-800">
            ₹{Math.round(item.price * item.quantity)}
          </p>
        </div>

        {/* REMOVE */}
        <button
          onClick={() => removeFromCart(item._id)}
          className="p-1 sm:p-2 text-red-500 hover:bg-red-50 rounded-lg sm:rounded-xl"
        >
          <Trash2 size={16} className="sm:hidden" />
          <Trash2 size={20} className="hidden sm:block" />
        </button>
      </div>

      {/* MOBILE SUBTOTAL */}
      <div className="flex justify-between mt-2 sm:hidden text-sm">
        <span className="text-gray-600">Subtotal</span>
        <span className="font-bold text-gray-800">
          ₹{Math.round(item.price * item.quantity)}
        </span>
      </div>
    </div>
  );
};

export default CartItem;
